/*!

=========================================================
* Black Dashboard React v1.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Dashboard from "views/Dashboard.js";

import UserProfile from "views/UserProfile.js";

import Upload_Tab from "views/Upload_Tab";

import PermintaanDonor from "views/PermintaanDonor";
import EdukasiPendonor from "views/EdukasiPendonor";
import donatur from "./assets/img/donator.png";
import blood from "./assets/img/blood_donasi.png";
import blood2 from "./assets/img/blood_test.png";
import blood3 from "./assets/img/blood-pressure.png";
import blood4 from "./assets/img/donor.png";
import blood5 from "./assets/img/donation.png";
import usersku from "./assets/img/teamwork.png";
import ResponPermintaan from "views/ResponPermintaan";
import ListDonatur from "views/ListDonatur";
import UsersGolda from "views/UsersGolda";
import DarahMasuk from "views/DarahMasuk";
import DarahKeluar from "views/DarahKeluar";
import HistoriDonor from "views/HistoriDonor";
import DonorStatistik from "views/DonorStatistik";
import WablasSettings from "views/WablasSettings";

var routes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    rtlName: "لوحة القيادة",
    icon: blood3,
    component: Dashboard,
    layout: "/admin",
    sidebar: true,
    user: true,
  },
  {
    path: "/permintaan-donor",
    name: "Permintaan Darah",
    rtlName: "ملف تفي للمستخدم",
    icon: blood5,
    component: PermintaanDonor,
    layout: "/admin",
    sidebar: true,
    user: true,
  },
  {
    path: "/edukasi-pendonor",
    name: "Edukasi Pendonor",
    rtlName: "تعليم المتبرعين",
    icon: blood4,
    component: EdukasiPendonor,
    layout: "/admin",
    sidebar: true,
    user: false, // Hanya admin
  },

  {
    path: "/upload",
    name: "Daftar Permintaan Darah",
    rtlName: "إخطارات",
    icon: blood,
    component: Upload_Tab,
    layout: "/admin",
    sidebar: true,
    user: true,
  },

  {
    path: "/progres",
    name: "Respon Permintaan",
    rtlName: "قائمة الجدول",
    icon: blood2,
    component: ResponPermintaan,
    layout: "/admin",
    sidebar: true,
    user: true,
  },

  {
    path: "/donatur",
    name: "Donatur",
    rtlName: "ملف تفي للمستخدم",
    icon: donatur,
    component: ListDonatur,
    layout: "/admin",
    sidebar: true,
    user: true,
  },

  {
    path: "/darah-masuk",
    name: "Darah Masuk",
    rtlName: "دم وارد",
    icon: blood5,
    component: DarahMasuk,
    layout: "/admin",
    sidebar: true,
    user: false, // Hanya admin
  },
  {
    path: "/darah-keluar",
    name: "Darah Keluar",
    rtlName: "دم خارج",
    icon: blood2,
    component: DarahKeluar,
    layout: "/admin",
    sidebar: true,
    user: false, // Hanya admin
  },

  {
    path: "/donor-statistik",
    name: "Statistik Donor",
    rtlName: "إحصائيات المتبرعين",
    icon: blood5,
    component: DonorStatistik,
    layout: "/admin",
    sidebar: true,
    user: false,
  },
  {
    path: "/histori-donor",
    name: "Histori Donor",
    rtlName: "تاريخ المتبرعين",
    icon: blood2,
    component: HistoriDonor,
    layout: "/admin",
    sidebar: true,
    user: false, // Hanya admin
  },
  {
    path: "/wablas-settings",
    name: "Pengaturan Wablas",
    rtlName: "إعدادات وابلس",
    icon: blood3,
    component: WablasSettings,
    layout: "/admin",
    sidebar: true,
    user: true, // Hanya admin
  },
  {
    path: "/users-donordarah",
    name: "Users Donor Darah",
    rtlName: "ملف تفي للمستخدم",
    icon: usersku,
    component: UsersGolda,
    layout: "/admin",
    sidebar: true,
    user: false,
  },
  {
    path: "/user-profile",
    name: "User Profile",
    rtlName: "ملف تفي للمستخدم",
    icon: blood4,
    component: UserProfile,
    layout: "/admin",
    sidebar: true,
    user: true,
  },
];
export default routes;
